module.exports = __webpack_public_path__ + "static/media/user_placeholder.5a021ab9.png";